import Image from 'next/image';
import Cta from '@/components/pages/cta';
import type { WaysToHelpContentItem } from '@jlg-website/database/types';

export default function WaysToHelpItem({ image, title, description, url }: WaysToHelpContentItem) {
  return (
    <div className="shrink-0 flex flex-col gap-6 w-[85vw] @lg:w-[910px]">
      <div className="relative h-[260px] @sm:h-[360px] @lg:h-[501px] rounded-2xl overflow-hidden">
        <Image
          src={image}
          alt={title}
          fill
          className="object-cover"
          sizes="(max-width: 640px) 85vw, (max-width: 1024px) 85vw, 910px"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-transparent to-black/50 rounded-2xl" />
        <h3
          className="absolute bottom-8 left-8 text-white font-serif font-medium leading-[1.1] tracking-[-1.04px] w-[466px] max-w-[80%]"
          style={{ fontSize: 'clamp(32px, 3.6vw, 52px)' }}
        >
          {title}
        </h3>
      </div>

      <div className="flex flex-col gap-6 @lg:flex-row @lg:items-start @lg:gap-14 @lg:justify-end">
        <p className="text-base leading-[1.5] tracking-[-0.4px] text-brand-text-button @lg:flex-1 @lg:text-xl @lg:leading-[1.3]">
          {description}
        </p>
        <Cta
          text="Learn more →"
          variation="outline"
          size="lg"
          href={url}
          className="w-full @lg:w-auto @lg:shrink-0"
        />
      </div>
    </div>
  );
}
